import { CorporateLocationParameters } from './../../models/corporate-location/corporate-locations-parameters.dto';
import { PagedResultDto } from './../../models/paged-result.model';
import { CreateCorporateLocationDto } from './../../models/corporate-location/create-corporate-location.dto';
import { UpdateCorporateLocationDto } from './../../models/corporate-location/update-corporate-location.dto';
import { CorporateLocationDto } from './../../models/corporate-location/corporate-location.dto';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpHelper } from '@umss/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class CorporateLocationsService {
  private readonly baseUrl = '/api/corporate-locations';
  private readonly http = inject(HttpClient);

  getAll(
    parameters: CorporateLocationParameters
  ): Observable<PagedResultDto<CorporateLocationDto>> {
    const params = HttpHelper.toHttpParams(parameters);
    return this.http.get<PagedResultDto<CorporateLocationDto>>(
      `${this.baseUrl}`,
      { params }
    );
  }

  get(corporateId: string): Observable<CorporateLocationDto> {
    return this.http.get<CorporateLocationDto>(
      `${this.baseUrl}/${corporateId}`
    );
  }

  create(
    payload: CreateCorporateLocationDto
  ): Observable<CorporateLocationDto> {
    return this.http.post<CorporateLocationDto>(`${this.baseUrl}`, payload);
  }

  update(
    id: string,
    payload: UpdateCorporateLocationDto
  ): Observable<CorporateLocationDto> {
    return this.http.put<CorporateLocationDto>(
      `${this.baseUrl}/${id}`,
      payload
    );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  setPrimary(id: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/set-primary`, null);
  }
}
